/**
 * Shared utility functions for sorting search results
 */
(function() {
  'use strict';

  window.SearchSortUtils = {
    /**
     * Get sort order based on source URL
     * @returns {Array} Array of sort rules with priorities
     */
    getSortOrder() {
      // Determine the best source URL for contextual sorting.
      // Header predictive search should use the current page URL.
      // On the search results page, we use the stored source URL (where the user came from).
      let sourceUrl = '';
      const storedSource = sessionStorage.getItem('search_source_url');
      const isOnSearchPage = window.location.pathname.includes('/search');

      if (isOnSearchPage && storedSource) {
        sourceUrl = storedSource.toLowerCase();
      } else {
        sourceUrl = window.location.href.toLowerCase();
      }
      
      // If still no URL, fall back to referrer
      if (!sourceUrl && document.referrer) {
        sourceUrl = document.referrer.toLowerCase();
      }
      
      const isYouthOrToddler = sourceUrl.includes('youth') || sourceUrl.includes('toddler');
      const isBag = sourceUrl.includes('bag') || sourceUrl.includes('handbag');

      // Define base sort order
      const baseOrder = [
        { type: 'Shoe', vendor: '*', priority: 1 },
        { type: 'Shoe', vendor: 'Nina Archive', priority: 2 },
        { type: 'Shoe', vendor: 'Nina Originals', priority: 3 },
        { type: 'Shoe', vendor: 'Daybreaks by Nina', priority: 4 },
        { type: 'Handbag', vendor: '*', priority: 5 },
        { type: 'Girl', vendor: '*', priority: 6 },
        { type: 'Jewelry', vendor: '*', priority: 7 }
      ];

      // Adjust priorities based on referrer
      if (isYouthOrToddler) {
        // Move 'Girl' to first
        baseOrder.forEach(item => {
          if (item.type === 'Girl') {
            item.priority = 0;
          } else {
            item.priority = item.priority + 1;
          }
        });
      } else if (isBag) {
        // Move 'Handbag' to first
        baseOrder.forEach(item => {
          if (item.type === 'Handbag') {
            item.priority = 0;
          } else {
            item.priority = item.priority + 1;
          }
        });
      }

      // Sort by priority
      baseOrder.sort((a, b) => a.priority - b.priority);

      return baseOrder;
    },

    /**
     * Get priority for a product based on its type and vendor
     * @param {string} productType - Product type
     * @param {string} productVendor - Product vendor
     * @param {Array} sortOrder - Sort order rules (optional, will be calculated if not provided)
     * @returns {number} Priority value (lower = higher priority)
     */
    getProductPriority(productType, productVendor, sortOrder = null) {
      if (!sortOrder) {
        sortOrder = this.getSortOrder();
      }

      // First, try to find an exact vendor match (more specific)
      for (const rule of sortOrder) {
        if (rule.type === productType && rule.vendor === productVendor && rule.vendor !== '*') {
          return rule.priority;
        }
      }

      // If no exact vendor match, fall back to wildcard match
      for (const rule of sortOrder) {
        if (rule.type === productType && rule.vendor === '*') {
          return rule.priority;
        }
      }

      // Default priority for products not in the list (higher number = lower priority)
      return 999;
    },

    /**
     * Sort an array of product block elements
     * @param {NodeList|Array} productBlocks - Product block elements to sort
     * @param {string} [searchQuery] - The search term; products whose title starts with
     *   this term are prioritized ahead of the type/vendor sort order
     * @returns {Array} Sorted array of product blocks
     */
    sortProductBlocks(productBlocks, searchQuery = null) {
      const blocksArray = Array.from(productBlocks);
      const sortOrder = this.getSortOrder();
      const normalizedQuery = (searchQuery || '').trim().toLowerCase();

      return blocksArray.sort((a, b) => {
        if (normalizedQuery) {
          const titleA = (a.getAttribute('data-product-title') || '').toLowerCase();
          const titleB = (b.getAttribute('data-product-title') || '').toLowerCase();
          const matchA = titleA.startsWith(normalizedQuery) ? 0 : 1;
          const matchB = titleB.startsWith(normalizedQuery) ? 0 : 1;

          if (matchA !== matchB) {
            return matchA - matchB;
          }
        }

        const typeA = a.getAttribute('data-product-type') || '';
        const vendorA = a.getAttribute('data-product-vendor') || '';
        const typeB = b.getAttribute('data-product-type') || '';
        const vendorB = b.getAttribute('data-product-vendor') || '';

        const priorityA = this.getProductPriority(typeA, vendorA, sortOrder);
        const priorityB = this.getProductPriority(typeB, vendorB, sortOrder);

        if (priorityA !== priorityB) {
          return priorityA - priorityB;
        }

        // If same priority, maintain original order
        return 0;
      });
    }
  };
})();

